var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.is_full_page_loader),expression:"is_full_page_loader"}],staticClass:"loading-page"},[_c('img',{attrs:{"src":require("../assets/images/loader.gif"),"alt":"loading"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }